import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { ComponentGate } from './ComponentGate';

interface ComponentCardProps {
  children: React.ReactElement;
  componentType?: string;
  typeList: string[];
}

/**
 * @author Jungwirth
 */
export const ComponentCard: React.FC<ComponentCardProps> = (props: Readonly<ComponentCardProps>): JSX.Element | null => {
  const { children, typeList, componentType } = props;

  return (
    <ComponentGate componentType={componentType} typeList={typeList}>
      <Card className="mb-2">
        <CardBody>
          {children}
        </CardBody>
      </Card>
    </ComponentGate>
  );
};
